import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Card, Form, Input, message } from "antd";
import { useForm } from "antd/es/form/Form";
import { useNavigate, useParams, useLocation } from "react-router";
import { useEffect } from "react";
import { accessService } from "../../../services/access.service";
import CardFooterAction from "../../../components/CardFooterAction";
import CustomTextInput from "../../../components/CustomTextInput";

export default function AccessForm() {
  const { id } = useParams();
  const [form] = useForm();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const location = useLocation();

  useEffect(() => {
    if (id) {
      const accessData = location.state?.access;
      if (accessData) {
        form.setFieldsValue(accessData);
      }
    }
  }, [form, id, location.state]);

  const storeMutation = useMutation({
    mutationFn: (data) => accessService.store(data),
    onSuccess: () => {
      queryClient.invalidateQueries("access");
      message.success("Data berhasil disimpan");
      form.resetFields();
      navigate("/setting/access");
    },
    onError: (error) => {
      console.error(error);
      message.error("Terjadi Kesalahan");
    },
  });

  const updateMutation = useMutation({
    mutationFn: ({ id, formData }) => accessService.update(id, formData),
    onSuccess: () => {
      queryClient.invalidateQueries("access");
      message.success("Data berhasil diubah");
      form.resetFields();
      navigate("/setting/access");
    },
    onError: (error) => {
      console.error(error);
      message.error("Terjadi Kesalahan");
    },
  });

  const isPending = storeMutation.isPending || updateMutation.isPending;

  const handleSubmit = (values) => {
    if (!id) {
      storeMutation.mutate(values);
    } else {
      updateMutation.mutate({ id, formData: values });
    }
  };

  return (
    <>
      <Card
        title={(id ? "Ubah" : "Tambah") + " Akses"}
        actions={[
          <CardFooterAction
            key={"1"}
            route={"/setting/access"}
            onClick={() => form.submit()}
            loading={isPending}
          />,
        ]}
      >
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <Form.Item hidden name={"id"}>
            <Input />
          </Form.Item>

          <CustomTextInput
            label="Nama Akses"
            name="name"
            rules={[
              {
                required: true,
                message: "Nama Akses tidak boleh kosong",
              },
            ]}
            disabled={isPending}
          />
        </Form>
      </Card>
    </>
  );
}
